export const ViewsStyles = {
  // Main button styles
  viewsButton: {
    textTransform: "none",

    "&:hover": {
      border: "0.5px solid #000",
    },
  },

  // Popover styles
  popover: {
    marginTop: 1,
  },
} as const;
